// src/hooks/useSedeGate.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API;

export default function useSedeGate(user) {
    const nav = useNavigate();

    useEffect(() => {
        let active = true;
        (async () => {
            if (!user) return;
            if (String(user.rol) !== '3') return;

            const token = localStorage.getItem('token');
            if (!token) { nav('/login', { replace: true }); return; }

            try {
                const { data } = await axios.get(`${API}/context/sede`, {
                    headers: { Authorization: `Bearer ${token}` },
                    withCredentials: true
                });
                if (!active) return;
                if (!data?.sedeId) {
                    console.warn('[useSedeGate] El asesor no tiene una sede asignada.');
                }
            } catch (err) {
                if (!active) return;
                const status = err?.response?.status;
                const code = err?.response?.data?.code;

                if (status === 428 || code === 'SEDE_REQUIRED') {
                    console.warn('[useSedeGate] El asesor requiere una sede asignada por Administración.');
                } else if (status === 401) {
                    nav('/login', { replace: true });
                } else {
                    console.warn('[useSedeGate]', err); // no lanzar ⇒ sin overlay
                    console.warn('[useSedeGate] El asesor requiere una sede asignada por Administración.');
                }
            }
        })();
        return () => { active = false; };
    }, [user, nav]);
}
